import React from 'react'
import LoadingPage from '../global/LoadingPage';
import { useBasicData } from '../../hooks/useBasicData';
import Navbar2 from './Navbar2/Navbar2';

const NavBar = () => {
    const { isLoading, basicData } = useBasicData()
    if (isLoading) return <LoadingPage />


    return (<Navbar2 data={basicData?.data} />)
}

export default NavBar